import { getEventDetails } from '@store/slices/eventSlice';
import { useSelector } from 'react-redux';
import { PartnerWithUsSectionWrapper, SubTitle, Title } from './styles';
import { useTranslation } from 'react-i18next';
import { Column } from '@components/LinearLayout';
import DownloadPartnerProspectus from '@composites/InboundButton/components/DownloadPartnerProspectus';
import { MLSID } from '@utils/pageBuilderHelper';
import { defaultInboundValues } from '@composites/InboundButton/utils';
import { ACCOUNT_ID, usePublicPortfolioByAccount } from '@utils/apiHooks';
import { useMemo } from 'react';
import { getImageSrc } from '@utils/fn';

interface PartnerWithUsSectionProos {
  width?: string;
}

const PartnerWithUsSection = ({ width }: PartnerWithUsSectionProos) => {
  const { t } = useTranslation();
  const sluggedEvent = useSelector(getEventDetails)?.[0];

  const portfolioSlug = sluggedEvent?.portfolio?.slug;
  const { data: portfolios } = usePublicPortfolioByAccount({
    accountId: ACCOUNT_ID,
  });
  const portfolio = useMemo(
    () => portfolios?.data?.find(p => p.slug === portfolioSlug),
    [portfolioSlug, portfolios?.data]
  );

  const inboundValues = {
    booleanValues: defaultInboundValues,
    nonBooleanValues: {},
  };

  return (
    <PartnerWithUsSectionWrapper
      width={width}
      bgImage={getImageSrc(portfolio?.design?.backgroundSvgImage || undefined)}
    >
      <Column $gap="3.2rem" $justifyContent="center" $alignItems="center">
        <Column $justifyContent="center" $alignItems="center">
          <Title $color={sluggedEvent?.design?.themeColor}>
            {t('partner-with-us')}
          </Title>
          <SubTitle $color={sluggedEvent?.design?.themeColor}>
            {t('partner-get-ready', {
              eventName: sluggedEvent?.name || '',
            })}
          </SubTitle>
        </Column>
        <DownloadPartnerProspectus
          label={t('download-partner-brochure')}
          buttonType={MLSID.PARTNER_PROSPECTUS_DOWNLOAD}
          inboundValues={inboundValues}
        />
      </Column>
    </PartnerWithUsSectionWrapper>
  );
};

export default PartnerWithUsSection;
